import React from 'react';
import useReset from '../../hooks/common/useReset';
import { sustainableBgState } from '../../data/estimate/common/modal/atom';
import { useRecoilValue } from 'recoil';
import Background from './Background';
import { POPUP_INDEX } from '../../styles/constants/priority';

/**
 *  background 배경을 컨트롤하는 공통 컴포넌트
 *  */
function BackgroundArea(): JSX.Element | null {
  // reset
  useReset(sustainableBgState);
  const sustainableBg: boolean = useRecoilValue(sustainableBgState);
  return <>{sustainableBg ? <Background zIndex={POPUP_INDEX - 1} /> : null}</>;
}

export default BackgroundArea;
